(function () {
    'use strict';

    angular.module("imApp").factory("ftpAccountsService", ['$ihttp', function ($ihttp) {
        let service = {
            listFtpAccounts: function (parms) {
                return $ihttp.post({
                    method: 968,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
